(function () {
  'use strict';

  var STORAGE_KEY = 'sterlings_wishlist';
  // Saved catalogues (Shopify collections) live in their own list so they never
  // collide with saved product ids and can be rendered separately.
  var STORAGE_KEY_COLLECTIONS = 'sterlings_wishlist_collections';

  // Some cards are built in JS (live-upcoming-auctions.js, sta-live-auction-lots.js,
  // live-auctions.js) with an empty .sta-wish-btn — the bookmark icon that card-product.liquid
  // inlines server-side is missing, so the heart is invisible though clickable. Inject the same
  // icon into any wish button that lacks it, from one place, so every render path is covered.
  var BOOKMARK_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" class="bookmark-ico">' +
    '<path class="bookmark-ico__inner-stroke" opacity="0.5" fill="#E8ECF7" d="M24.6,27.1V3.3H7.4v23.8l8.6-4.9L24.6,27.1z M8.5,4.5h15v20.6L16,20.9l-7.5,4.2V4.5z"/>' +
    '<path class="bookmark-ico__inner-fill" fill="#243E87" d="M16,22.2l8.6,4.9V3.3H7.4v23.8L16,22.2z"/>' +
    '<path class="bookmark-ico__base-stroke" fill="#243E87" d="M25.8,29L16,23.5L6.2,29V2.2h19.6V29z M16,22.2l8.6,4.9V3.3H7.4v23.8L16,22.2z"/>' +
    '<path class="bookmark-ico__outer-stroke" opacity="0.5" fill="#E8ECF7" d="M5.1,1v30L16,24.8L26.9,31V1H5.1z M25.8,29L16,23.5L6.2,29V2.2h19.6V29z"/>' +
    '<path class="bookmark-ico__plus" fill="#243E87" d="M21.2,12.5h-4.6v4.6h-1.2v-4.6h-4.6v-1.2h4.6V6.8h1.2v4.6h4.6V12.5z"/>' +
    '<path class="bookmark-ico__minus" fill="#FFFFFF" d="M21.2,12.5H10.8v-1.2h10.4V12.5z"/>' +
    '</svg>';

  function ensureBookmarkIcon(btn) {
    if (btn && !btn.querySelector('svg')) btn.innerHTML = BOOKMARK_ICON;
  }

  function cfg() {
    var c = window.STA_WISHLIST || {};
    return {
      customerId:
        (c.customerId != null && String(c.customerId).trim()) ||
        (window.staCurrentCustomerId ? window.staCurrentCustomerId() : '') ||
        '',
      laravelBase: String(
        c.laravelBase || localStorage.getItem('sterlings_laravel_url') || ''
      ).replace(/\/+$/, ''),
      laravelKey: String(c.laravelKey || localStorage.getItem('sterlings_laravel_key') || ''),
    };
  }

  function readIds() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function writeIds(ids) {
    var unique = [];
    ids.forEach(function (id) {
      id = String(id || '').trim();
      if (id && unique.indexOf(id) === -1) unique.push(id);
    });
    localStorage.setItem(STORAGE_KEY, JSON.stringify(unique));
    document.dispatchEvent(
      new CustomEvent('sta:wishlist-changed', { detail: { ids: unique } })
    );
    return unique;
  }

  function has(productId) {
    return readIds().indexOf(String(productId)) !== -1;
  }

  function toggle(productId) {
    var id = String(productId || '').trim();
    if (!id) return false;
    var ids = readIds();
    var idx = ids.indexOf(id);
    var added;
    if (idx === -1) {
      ids.push(id);
      added = true;
    } else {
      ids.splice(idx, 1);
      added = false;
    }
    writeIds(ids);
    return added;
  }

  // ---- Saved catalogues (collections) — parallel storage to products ----
  function readCollectionIds() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY_COLLECTIONS);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.map(String) : [];
    } catch (e) {
      return [];
    }
  }

  function writeCollectionIds(ids) {
    var unique = [];
    ids.forEach(function (id) {
      id = String(id || '').trim();
      if (id && unique.indexOf(id) === -1) unique.push(id);
    });
    localStorage.setItem(STORAGE_KEY_COLLECTIONS, JSON.stringify(unique));
    document.dispatchEvent(
      new CustomEvent('sta:wishlist-changed', { detail: { collectionIds: unique } })
    );
    return unique;
  }

  function hasCollection(collectionId) {
    return readCollectionIds().indexOf(String(collectionId)) !== -1;
  }

  function toggleCollection(collectionId) {
    var id = String(collectionId || '').trim();
    if (!id) return false;
    var ids = readCollectionIds();
    var idx = ids.indexOf(id);
    var added;
    if (idx === -1) {
      ids.push(id);
      added = true;
    } else {
      ids.splice(idx, 1);
      added = false;
    }
    writeCollectionIds(ids);
    return added;
  }

  function resolveCollectionId(btn) {
    if (!btn) return '';
    return (btn.getAttribute('data-collection-id') || '').trim();
  }

  function productIdFromHandle(handle) {
    if (!handle) return '';
    var normalized = String(handle).trim().toLowerCase();
    var nodes = document.querySelectorAll('ul.urls-check-cards-products li[data-product-id][data-href]');
    for (var i = 0; i < nodes.length; i++) {
      var href = String(nodes[i].getAttribute('data-href') || '').toLowerCase();
      if (href === '/products/' + normalized || href.indexOf('/products/' + normalized) !== -1) {
        return String(nodes[i].getAttribute('data-product-id') || '').trim();
      }
    }
    return '';
  }

  function resolveProductId(btn) {
    if (!btn) return '';
    var direct = (btn.getAttribute('data-product-id') || '').trim();
    if (direct) return direct;

    var productInfo = btn.closest('product-info');
    if (productInfo) {
      var fromInfo = (productInfo.getAttribute('data-product-id') || '').trim();
      if (fromInfo) return fromInfo;
    }

    var card = btn.closest('.sta-product-card, .sta-collection-products__product, .sta-hero-product');
    if (card) {
      var link =
        card.querySelector('.sta-product-card__title a[href*="/products/"]') ||
        card.querySelector('.sta-product-card__ill[href*="/products/"]') ||
        card.querySelector('a[href*="/products/"]');
      if (link) {
        var m = String(link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/i);
        if (m) {
          var fromMap = productIdFromHandle(m[1]);
          if (fromMap) return fromMap;
        }
      }
    }
    return '';
  }

  function applyBtnState(btn, productId) {
    if (!btn || !productId) return;
    var saved = has(productId);
    btn.classList.toggle('_in-list', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', saved ? 'Remove from saved lots' : 'Save lot');
    btn.title = saved ? 'Remove from saved lots' : 'Save lot';
  }

  function applyCollectionBtnState(btn, collectionId) {
    if (!btn || !collectionId) return;
    var saved = hasCollection(collectionId);
    btn.classList.toggle('_in-list', saved);
    btn.setAttribute('aria-pressed', saved ? 'true' : 'false');
    btn.setAttribute('aria-label', saved ? 'Remove saved catalogue' : 'Save catalogue');
    btn.title = saved ? 'Remove saved catalogue' : 'Save catalogue';
  }

  function syncAllButtons() {
    document.querySelectorAll('.sta-wish-btn').forEach(function (btn) {
      ensureBookmarkIcon(btn);
      var collectionId = resolveCollectionId(btn);
      if (collectionId) applyCollectionBtnState(btn, collectionId);
      else applyBtnState(btn, resolveProductId(btn));
    });
    syncCountBadges();
  }

  /** Live count on the header bookmark icon (and any [data-wishlist-count] element). */
  function syncCountBadges() {
    var count = readIds().length + readCollectionIds().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count > 99 ? '99+' : String(count);
      if (count > 0) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    });
  }

  function apiHeaders(key) {
    var h = { Accept: 'application/json', 'ngrok-skip-browser-warning': 'true' };
    if (key) h['X-Secret-Key'] = key;
    return h;
  }

  function syncApi(productId, add) {
    var c = cfg();
    if (!c.laravelBase || !c.customerId || !productId) return Promise.resolve();
    var url =
      c.laravelBase +
      '/api/v1/customers/' +
      encodeURIComponent(c.customerId) +
      '/wishlists/product/' +
      encodeURIComponent(String(productId));
    return fetch(url, {
      method: add ? 'PUT' : 'DELETE',
      headers: apiHeaders(c.laravelKey),
      mode: 'cors',
    }).catch(function () {});
  }

  function syncCollectionApi(collectionId, add) {
    var c = cfg();
    if (!c.laravelBase || !c.customerId || !collectionId) return Promise.resolve();
    var url =
      c.laravelBase +
      '/api/v1/customers/' +
      encodeURIComponent(c.customerId) +
      '/wishlists/collection/' +
      encodeURIComponent(String(collectionId));
    return fetch(url, {
      method: add ? 'PUT' : 'DELETE',
      headers: apiHeaders(c.laravelKey),
      mode: 'cors',
    }).catch(function () {});
  }

  function loadFromApi() {
    var c = cfg();
    if (!c.laravelBase || !c.customerId) return Promise.resolve();

    return fetch(
      c.laravelBase + '/api/v1/customers/' + encodeURIComponent(c.customerId) + '/wishlists',
      { headers: apiHeaders(c.laravelKey), mode: 'cors' }
    )
      .then(function (r) {
        if (!r.ok) return null;
        return r.json();
      })
      .then(function (payload) {
        if (!payload) return;
        var data = payload.data || payload;

        var items = data.items;
        if (Array.isArray(items)) {
          var ids = readIds().slice();
          items.forEach(function (item) {
            var pid =
              item.product_id ||
              item.shopify_product_id ||
              (item.product && (item.product.shopify_id || item.product.id));
            if (pid != null && String(pid).trim()) {
              pid = String(pid).trim();
              if (ids.indexOf(pid) === -1) ids.push(pid);
            }
          });
          writeIds(ids);
        }

        var collections = data.collections;
        if (Array.isArray(collections)) {
          var cids = readCollectionIds().slice();
          collections.forEach(function (item) {
            var cid =
              item.collection_id ||
              item.shopify_collection_id ||
              (item.collection && (item.collection.shopify_id || item.collection.id));
            if (cid != null && String(cid).trim()) {
              cid = String(cid).trim();
              if (cids.indexOf(cid) === -1) cids.push(cid);
            }
          });
          writeCollectionIds(cids);
        }
      })
      .catch(function () {});
  }

  function onClick(e) {
    var btn = e.target.closest('.sta-wish-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    // Catalogue (collection) buttons carry data-collection-id; route them to the
    // collection wishlist. Everything else is a product bookmark as before.
    var collectionId = resolveCollectionId(btn);
    if (collectionId) {
      var addedCollection = toggleCollection(collectionId);
      syncAllButtons();
      syncCollectionApi(collectionId, addedCollection);
      return;
    }

    var productId = resolveProductId(btn);
    if (!productId) return;

    var added = toggle(productId);
    syncAllButtons();
    syncApi(productId, added);
  }

  document.addEventListener('click', onClick);
  document.addEventListener('sta:wishlist-changed', syncAllButtons);

  // Many cards are injected after page load (live-auctions.js past/live catalogues,
  // live-upcoming-auctions.js, sta-live-auction-lots.js). Those render an empty
  // .sta-wish-btn, so without a re-sync their bookmark icon stays uninjected (and
  // invisible) until a click fires sta:wishlist-changed. Watch for newly added wish
  // buttons and re-sync so the icon + saved state appear immediately.
  var observer = null;
  var syncScheduled = false;

  var defer = window.requestAnimationFrame
    ? function (fn) { window.requestAnimationFrame(fn); }
    : function (fn) { window.setTimeout(fn, 16); };

  function scheduleSync() {
    if (syncScheduled) return;
    syncScheduled = true;
    defer(function () {
      syncScheduled = false;
      // Detach while we mutate button internals (icon injection) so our own DOM
      // writes don't re-trigger the observer.
      if (observer) observer.disconnect();
      syncAllButtons();
      startObserving();
    });
  }

  function addsWishButton(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (!node || node.nodeType !== 1) continue;
        if (node.matches && node.matches('.sta-wish-btn')) return true;
        if (node.querySelector && node.querySelector('.sta-wish-btn')) return true;
      }
    }
    return false;
  }

  function startObserving() {
    if (!('MutationObserver' in window) || !document.body) return;
    if (!observer) {
      observer = new MutationObserver(function (mutations) {
        if (addsWishButton(mutations)) scheduleSync();
      });
    }
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    loadFromApi().finally(syncAllButtons);
    startObserving();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.staWishlistHas = has;
  window.staWishlistToggle = toggle;
  window.staWishlistSyncButtons = syncAllButtons;
  window.staWishlistIds = readIds;
})();
